import { render, staticRenderFns } from "./TooltipWithClose.vue?vue&type=template&id=0c04e623&"
import script from "./TooltipWithClose.vue?vue&type=script&lang=ts&"
export * from "./TooltipWithClose.vue?vue&type=script&lang=ts&"
import style0 from "./TooltipWithClose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports